module.exports = __webpack_public_path__ + "img/logofb.ca7354ae.png";